"use client";
import { jsx } from "react/jsx-runtime";
import { component } from "@gnist/component-utils";
import { tokens } from "@gnist/themes/tokens.css.js";
import { calc } from "@vanilla-extract/css-utils";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import { useExtraIcons } from "./ExtraIconsProvider.js";
import { iconContainer, svg, svgWidth, svgHeight } from "./Icon.css.js";
import { icons } from "./icons.js";
import { useIconVariant } from "./IconVariantProvider.js";
const IconContainer = ({ icon, title, size: sizeToken = "l", fill = "currentColor", focusable = false, "aria-label": ariaLabel, "aria-hidden": ariaHidden = title || ariaLabel ? false : true, role = "img", className, variantOverride, ...rest }) => {
  const defaultVariant = useIconVariant();
  const variant = variantOverride || defaultVariant;
  const extraIcons = useExtraIcons();
  const iconSpec = icons[icon] ?? extraIcons[icon];
  if (!iconSpec) {
    console.error(`Unsupported icon ${icon}`);
    return null;
  }
  let IconComponent = iconSpec.variants[variant];
  if (!IconComponent) {
    const [variantName, component2] = Object.entries(iconSpec.variants)[0];
    console.error(`Unsupported variant "${variant}" for icon "${icon}". Falling back to first defined variant ${variantName}.`);
    IconComponent = component2;
  }
  const size = sizeToken === "1em" ? sizeToken : tokens.size[sizeToken];
  const { fit, scale } = (icons[icon] ?? extraIcons[icon]).options;
  const iconSize = calc.multiply(size, scale);
  return jsx("span", { className: classNames(className, iconContainer), style: {
    ...assignInlineVars({
      [svgHeight]: fit === "height" ? iconSize : "auto",
      [svgWidth]: fit === "width" ? iconSize : "auto"
    }),
    height: size,
    width: size
  }, children: jsx(IconComponent, { className: svg, fill, focusable, "aria-label": ariaLabel, "aria-hidden": ariaHidden, role, title, ...rest }) });
};
const Icon = component("Icon", iconContainer, IconContainer);
export {
  Icon
};
